import React, { Fragment, useRef, useState } from 'react';
import { H3, Span, pixelToRem, H4 } from '../ui';
import { colors } from '../../modules/theme';
import useGlobalState from '../../hooks/use-global-state';
import { setActiveFrogType } from '../../modules/app-duck';
import { formatNum } from '../../modules/format-number';
import { useIsSmallMobile } from '../../hooks/mobile';

const HeadlineOrButton = ({ activeFrogName, onClick }) => {
  const isMobile = useIsSmallMobile();

  if (isMobile || !activeFrogName) {
    return (
      <H4
        css={{
          padding: '0 15px',
          fontSize: pixelToRem(13),
          color: 'white',
          lineHeight: '18pt',
        }}
      >
        Select a species to see the distribution on the map
      </H4>
    );
  }
  return (
    <button
      css={{
        padding: '0 15px',

        border: 'none',
        background: 'none',
        cursor: 'pointer',
        color: 'white',
        fontSize: pixelToRem(13),
        lineHeight: '18pt',

        textDecoration: 'underline',
      }}
      onClick={onClick}
    >
      Deselect "{activeFrogName}"
    </button>
  );
};

const FrogList = ({ frogs }) => {
  const { dispatch, state } = useGlobalState();
  const audioRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const playOrPause = () => {
    if (isPlaying) {
      setIsPlaying(false);
      audioRef.current.pause();
    } else {
      setIsPlaying(true);
      audioRef.current.play();
    }
  };
  return (
    <Fragment>
      <div>
        <HeadlineOrButton
          onClick={() => dispatch(setActiveFrogType(undefined))}
          activeFrogName={
            state.activeFrogType &&
            frogs.find(frog => frog.id === state.activeFrogType).common_name
          }
        />

        <div
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 15px',
          }}
        >
          <H4 css={{ fontWeight: 'normal', color: 'white' }}>Frog species</H4>
          <H4 css={{ fontWeight: 'normal', color: 'white' }}>
            Records <span>▼</span>
          </H4>
        </div>
      </div>
      <ul css={{ listStyle: 'none', overflowY: 'auto', borderRadius: '4px' }}>
        {frogs.map(frog => {
          const activeFrog = frog.id === state.activeFrogType;
          return (
            <li
              css={{
                marginTop: 2,
              }}
              key={frog.id}
            >
              {activeFrog && (
                <audio
                  preload="auto"
                  ref={audioRef}
                  css={{ display: 'none' }}
                  src={frog.audio_url}
                >
                  Your browser does not support the
                  <code>audio</code> element.
                </audio>
              )}
              <button
                onClick={() => {
                  dispatch(setActiveFrogType(activeFrog ? undefined : frog.id));
                  if (isPlaying) {
                    audioRef.current.pause();
                    setIsPlaying(false);
                  }
                }}
                css={{
                  background: activeFrog
                    ? 'rgba(255, 255, 255, 0.2)'
                    : colors.reallyDarkBlue,
                  padding: '5px 15px',
                  border: 'none',
                  margin: 0,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  color: 'white',
                  cursor: 'pointer',
                  alignItems: activeFrog ? 'center' : 'flex-end',
                }}
              >
                <div css={{ textAlign: 'left' }}>
                  <H3>{frog.common_name}</H3>
                  <H4
                    css={{
                      fontStyle: 'italic',
                      fontWeight: 'normal',
                      color: 'white',
                    }}
                  >
                    {frog.latin_name}
                  </H4>
                </div>
                {activeFrog ? (
                  <div
                    tabIndex="0"
                    role="button"
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        playOrPause();
                      }
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      playOrPause();
                    }}
                  >
                    <img
                      css={{ width: 38, height: 38 }}
                      src={
                        process.env.URL +
                        (isPlaying ? '/pause.svg' : '/play.svg')
                      }
                      alt={isPlaying ? 'pause' : 'play'}
                    />
                  </div>
                ) : (
                  <Span
                    css={{
                      fontSize: pixelToRem(14),
                      lineHeight: '18pt',
                      fontWeight: 'normal',
                    }}
                  >
                    {formatNum(frog.submissions)}
                  </Span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </Fragment>
  );
};
export default FrogList;
